import React, { useState, useRef, useEffect } from 'react';
import {
  TextField,
  InputAdornment,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import MKBox from "components/MKBox";
import routes from "routes";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import SimpleFooter from "examples/Footers/SimpleFooter";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve();
    script.onerror = (err) => reject(err);
    document.body.appendChild(script);
  });

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

const SignUpPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [confirmpassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSignInEnabled, setIsSignInEnabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');

  useEffect(() => {
    const passwordsMatch = password === confirmpassword;
    const isPasswordComplexEnough = checkPasswordComplexity(password);
    setIsSignInEnabled(passwordsMatch && isPasswordComplexEnough);
  }, [password, confirmpassword]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
  };

  const checkPasswordComplexity = (password) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialCharacter = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);

    return (
      password.length >= minLength &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSpecialCharacter
    );
  };

  const isButtonDisabled = !(
    name &&
    email &&
    password &&
    isSignInEnabled
  );

  const [bbData, setBbData] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [loading, setLoading] = useState(false);

  // const handleSubmit = (e) => {
  //   setLoading(true);
  //   e.preventDefault();
  //   const data = {
  //     username: name,
  //     email: email,
  //     password: password,
  //     groups: [2],
  //   };
  //   fetch(`${process.env.REACT_APP_API_URL}/api/register/`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     body: JSON.stringify(data),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setBbData(data);
  //       if (data.groups[0] === "2") {
  //         setLoading(false);
  //         setSubmitCompleted(true);
  //         console.log('Form submitted!');
  //       } else {
  //         console.log('data.email[0]',data.email[0]);
  //         setLoading(false);
  //         setErrorMessage(data.email[0]);
  //         setSubmitCompleted(false);
  //       }
  //     })
  //     .catch((error) => {
  //       // window.location.reload();
  //       console.log('error',error);
  //       setLoading(false);
  //     });
  // };

  const handleSubmit = (e) => {
    setLoading(true);
    setErrorMessage("");
    e.preventDefault();
    const data = {
      username: name,
      email: email,
      password: password,
      groups: [2],
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/register/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        setBbData(data);
        if (data.email && data.email.length > 0 && data.email !== email) {
          console.log('data.email[0]', data.email);
          setLoading(false);
          setErrorMessage(data.email[0]);
          setSubmitCompleted(false);
          setPassword('');
          setConfirmPassword('');
        } else if (data.groups && data.groups.length > 0 && data.groups[0] === 2) {
          setLoading(false);
          setSubmitCompleted(true);
          console.log('Form submitted!');
          setPassword('');
          setConfirmPassword('');
        } else {
          setLoading(false);
          console.log('Unknown response:', data);
          setPassword('');
          setConfirmPassword('');
        }
      })
      .catch((error) => {
        // window.location.reload();
        console.log('error', error);
        setLoading(false);
      });
  };

  console.log(bbData);

  const OnOkClick = () => {
    window.location.href = "/portal";
  };

  const googleButton = useRef(null);

  useEffect(() => {
    const src = 'https://accounts.google.com/gsi/client';
    // const clientId = "1086866642031-on7hrdcvallmkia5d367uq6ni0impi1i.apps.googleusercontent.com"

    const CLIENT_ID = `${process.env.REACT_APP_CLIENTID}`;

    loadScript(src)
      .then(() => {
        /*global google*/
        google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: handleCredentialResponse,
        });
        google.accounts.id.renderButton(googleButton.current, {
          theme: 'outline',
          size: 'large',
        });
      })
      .catch(console.error);

    return () => {
      const scriptTag = document.querySelector(`script[src="${src}"]`);
      if (scriptTag) document.body.removeChild(scriptTag);
    };
  }, [loading]);

  function handleCredentialResponse(response) {
    if (response.credential) {
      var data = { groups: "2", auth_token: response.credential };
      console.log("response.credential");
      console.log(response.credential);
      console.log("data", data);
      let authstatus = "register";
      fetch(`${process.env.REACT_APP_API_URL}/api/google/${authstatus}`, {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("hwweeeeeeeeeeeeeeeee", res);
          console.log("hwweeeeeeeeeeeeeeeee", res);
          if (res && res[0]) {
            setErrorMessage(res[0]);
          } else {
            let email = res['email'];
            console.log("mail", email);
            let token = res['tokens'];
            let access_token = token.access;
            console.log("toke", access_token);
            let user_id = res["user_id"];
            let username = res["username"];
            let is_verified_mobile = res["is_verified_mobile"];
            let is_verified = res["is_verified"];
            let is_verified_tc = res["is_verified_tc"];
            let groups = res["groups"];
            console.log("groups", groups);

            localStorage.setItem("userId", user_id);
            localStorage.setItem("user", username);
            localStorage.setItem("verified", is_verified);
            localStorage.setItem("verified_tc", is_verified_tc);
            localStorage.setItem("group", groups);

            localStorage.setItem("email", email);
            localStorage.setItem("token", access_token);

            console.log("email", localStorage.getItem("email"));
            console.log("token", localStorage.getItem("token"));
            console.log("group", localStorage.getItem("group"));

            let tc_status = localStorage.getItem("verified_tc");
            let mobile_status = localStorage.getItem("mobile");
            if (JSON.parse(tc_status) === false) {
              window.location.href = "/app/trainerdashboard";
            } else if (JSON.parse(mobile_status) === false) {
              window.location.href = "/app/trainerdashboard";
            } else {
              window.location.href = "/app/trainerdashboard";
            }
          }
        })
        .catch((error) => {
          setErrorMessage(error);
          console.log('error', error);
          setLoading(false);
        });

    }
  }


  return (
    <>
      <LoadingOverlay loading={loading}>
        <DefaultNavbar
          routes={routes}
          sticky
        />
        <MKBox
          position="absolute"
          top={0}
          left={0}
          zIndex={1}
          width="100%"
          minHeight="100vh"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.6),
                rgba(gradients.dark.state, 0.6)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <MKBox px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
          <Grid container spacing={1} justifyContent="center" alignItems="center" height="101%">
            <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  mx={2}
                  mt={-3}
                  p={-3}
                  mb={-2}
                  textAlign="center"
                >
                  <MKTypography variant="h4" fontWeight="medium" color="white" mt={1} mb={1} style={{ marginBottom: "-15px" }}>
                    Join us using
                  </MKTypography>
                  <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 1 }}>
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                      <div id='google-login-btn'>
                        <div ref={googleButton} id='google-ref'></div>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontWeight: "medium",
                          fontSize: "18px",
                          backgroundColor: "white",
                          width: "80%",
                          marginLeft: "35px",
                        }}
                      >
                        <MKTypography variant="h7" fontWeight="medium" color="white">
                          or
                        </MKTypography>
                      </Divider>
                    </Grid>
                    <MKTypography
                      variant="h6"
                      fontWeight="medium"
                      color="white"
                      mt={1}
                      style={{ marginLeft: "20px", marginBottom: "10px" }}
                    >
                      Sign Up with Credentials
                    </MKTypography>
                  </Grid>
                </MKBox>
                <MKBox pt={4} pb={3} px={3}>
                  <MKBox component="form" role="form">
                    <MKBox mb={2}>
                      <MKInput type="name" label="Name" disabled={loading} onChange={handleNameChange} fullWidth required />
                    </MKBox>
                    <MKBox mb={2}>
                      <MKInput type="email" label="Email" disabled={loading} onChange={handleEmailChange} fullWidth required />
                    </MKBox>
                    <MKBox mb={2}>
                      <TextField
                        fullWidth
                        label="Password"
                        value={password}
                        onChange={handlePasswordChange}
                        type={showPassword ? 'text' : 'password'}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip placement="top"
                                title={
                                  <div>
                                    <span style={{ whiteSpace: 'nowrap' }}> Min character length is 8</span>
                                    <span style={{ whiteSpace: 'nowrap' }}> At least one uppercase letter</span>
                                    <span style={{ whiteSpace: 'nowrap' }}> At least one lowercase letter</span>
                                    <span style={{ whiteSpace: 'nowrap' }}> At least one number</span>
                                    <span style={{ whiteSpace: 'nowrap' }}> At least one special character</span>
                                  </div>
                                }>
                                <InfoIcon style={{ cursor: 'pointer', marginRight: '8px' }} />
                              </Tooltip>
                              {showPassword ? (
                                <VisibilityOff
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Visibility
                                  onClick={handleTogglePasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MKBox>
                    <MKBox mb={2}>
                      <TextField
                        fullWidth
                        label="Confirm Password"
                        value={confirmpassword}
                        onChange={handleConfirmPasswordChange}
                        type={showConfirmPassword ? 'text' : 'password'}
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {showConfirmPassword ? (
                                <VisibilityOff
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <Visibility
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  style={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MKBox>
                    <div>
                      {errorMessage && <MKTypography variant="subtitle2" color="error">{errorMessage}</MKTypography>}
                    </div>
                    <MKBox mt={1} mb={1}>
                      <MKButton variant="gradient"
                        color="info"
                        onClick={handleSubmit}
                        fullWidth
                        type="submit"
                        disabled={isButtonDisabled}>
                        Create Account
                      </MKButton>
                    </MKBox>
                  </MKBox>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </MKBox>
        <Dialog
          open={submitCompleted}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Bravo!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You've just elevated your status to official trainer extraordinaire with us. Get ready to inspire and make a lasting impact – welcome to the league of exceptional trainers!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MKButton variant="gradient" onClick={() => { OnOkClick(); }} color="info" size="small" autoFocus>
              OK
            </MKButton>
          </DialogActions>
        </Dialog>
        <MKBox width="100%" position="absolute" zIndex={1} bottom="1.625rem">
          <SimpleFooter light />
        </MKBox>
      </LoadingOverlay>
    </>
  );
};

export default SignUpPage;